export default "__VITE_ASSET__BBEPHi7y__"